export class VendorConstants {
    static readonly COMMUNITY_VENDOR = 'community';
    static readonly ALL_VENDOR = 'all';
    static readonly TEMP_VENDOR = 'temporary';
}
